import { Component } from '@angular/core'

@Component({
    selector: 'sf-dashboard-customers',
    templateUrl: './dashboard-customers.component.html',
    styleUrls: ['./dashboard-customers.component.scss'],
    standalone: false
})
export class DashboardCustomersComponent {}
